import React from 'react'
import DocumentManagementHero from './DocumentManagementHero'
import CallToAction from '../../../../LandingSection/CallToAction'
import Footer from '../../../../Components/Footer'
import Header from '../../../../Components/Header'
import Challenge from './Challenge'
import OurSolution from './OurSolution'
import DocumentManagementTechSolutions from './DocumentManagementTechSolutions'

const DocumentManagementCaseStudyPage = () => {
  return (
    <>
      <Header bgColor="#121212"/>
      <DocumentManagementHero />
      <DocumentManagementTechSolutions />
      <Challenge />
      <OurSolution />
      <CallToAction/>
      <Footer/>
    </>
  )
}

export default DocumentManagementCaseStudyPage
